import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog'
import { TranslateModule } from '@ngx-translate/core'

import { MultiVisitReviewCharge } from '../../../services/estimate-balance-presenter.service'
import { BalanceChargeBreakdownComponent } from '../balance-charge-breakdown/balance-charge-breakdown.component'

export interface BalanceChargeBreakdownDialogData {
  charges: readonly MultiVisitReviewCharge[]
  total: number
}


@Component({
  selector: 'mmx-balance-charge-breakdown-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatDialogModule, TranslateModule, BalanceChargeBreakdownComponent],
  templateUrl: './balance-charge-breakdown-dialog.component.html',
  styleUrls: ['./balance-charge-breakdown-dialog.component.scss'],
})
export class BalanceChargeBreakdownDialogComponent {
  readonly data = inject<BalanceChargeBreakdownDialogData>(MAT_DIALOG_DATA)
  readonly chargeCount = this.data.charges.length
}
